import React, { useEffect, useState } from "react";
import {
  Box,
  ButtonStyled,
  HeadingStyled,
  HeadingStyledSm,
  SpanStyled,
} from "../../../../../components/styled/Elements";
import { useTranslation } from "react-i18next";
import {
  BackArrow,
  BackwardArrow,
  ForwardArrow,
  LocationPin,
  Whatsapp,
} from "../../../../../components/styled/AllImages";
import { useUser } from "../../../../../context/userContext";
import PropertiesApi from "../../../../../services/api/propertiesApi";
import { formateAmounts } from "../../../../../utils";
import {
  buildAdvertiserRoleOptions,
  resolveAdvertiserRoleLabel,
} from "../../../../../utils/advertiserRoles";

// Import additional modules if needed

const VisitorLookingForCards = ({ showAll, setShowAll, listings, user }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const [isDesktop, setIsDesktop] = useState(window.innerWidth < 767);
  const [advertiserTypes, setAdvertiserTypes] = useState([]);

  const propertiesList = listings || [];
  const [propertyId, setPropertyId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  // const handleCloseModal = () => setShowModal(false);
  const WhatsApp = () => {
    const phoneNumber = user?.phone;
    const message = t("hello");
    const whatsappURL = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(
      message
    )}`;
    window.open(whatsappURL, "_blank");
  };

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth < 767);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const getAdvertiserTypes = async () => {
      try {
        const response = await PropertiesApi.getListingStatuses();
        setAdvertiserTypes(
          buildAdvertiserRoleOptions(response?.data?.advertiser_types)
        );
      } catch (error) {
        setAdvertiserTypes(buildAdvertiserRoleOptions());
      }
    };

    getAdvertiserTypes();
  }, [language]);

  return (
    <>
      <Box className="d-flex justify-content-between w-100 align-items-center mb-4">
        <Box className="d-flex gap-2 align-items-center">
          {showAll && (
            <BackArrow
              onClick={() => setShowAll(false)}
              style={{
                transform: language === "ar" ? "scale(-1)" : "scale(1)",
              }}
            />
          )}
          <HeadingStyled size="24px">
            {t("properties_i_seek")}
          </HeadingStyled>
        </Box>

        {!showAll && propertiesList.length > 3 && (
          <Box className="d-flex gap-1" onClick={() => setShowAll(true)}>
            <SpanStyled
              color="var(--themeColorSecondary)"
              style={{ textWrap: "nowrap" }}
              weight="bold"
            >
              {t("ViewAll")}
            </SpanStyled>
            <Box>{language == "en" ? <BackwardArrow /> : <ForwardArrow />}</Box>
          </Box>
        )}
      </Box>
      {propertiesList.length > 0 ? (
        <Box
          className={`propertiesGridWrapper ${
            showAll && "flex-wrap overflow-visible"
          } `}
        >
          {propertiesList
            .slice(0, showAll ? propertiesList.length : 3)
            .map((item, key) => (
              <Box
                className={`px-1 ${
                  isDesktop && !showAll
                    ? "col-sm-6 col-9"
                    : isDesktop && showAll && "col-12"
                }`}
                key={key}
              >
                <Box className="colPropertiesGrid pb-md-4">
                  <Box className="titleLocationWrapper">
                    <Box className="titleLocation d-flex justify-content-between flex-column gap-3">
                      <HeadingStyled size="18px">{`${t("looking_to")} ${t(
                        item.type == 1 ? t("Rent") : t("Buy")
                      )}`}</HeadingStyled>

                      {item?.price && (
                        <Box className="d-flex gap-1 align-items-end budget-box">
                          <HeadingStyled size="17px" className="budget-heading">{t("budget")}:</HeadingStyled>
                          <SpanStyled
                            color="var(--darkGrey)"
                            size="17px"
                            className="price-wrapper"
                          >
                            {formateAmounts(item?.price)}
                          </SpanStyled>
                        </Box>
                      )}
                    </Box>
                  </Box>
                  <Box className="peopleLocationRole mt-1">
                    <SpanStyled
                      size="14px"
                      color="var(--lightGrey)"
                      className="d-flex gap-1"
                    >
                      <Box>
                        <LocationPin />
                      </Box>{" "}
                      {item?.cities_data
                        .map((city) =>
                          language === "en" ? city.name_en : city.name_ar
                        )
                        .join(" | ")}
                    </SpanStyled>
                  </Box>
                  <Box className="advIdentityWrapper">
                    <Box className="advIdentityPlatform ">
                      <SpanStyled size="14px" color="var(--lightGrey)">
                        {t("Property_category")}
                      </SpanStyled>
                      <br />
                      <HeadingStyledSm
                        size="14px"
                        color="var(--darkGrey)"
                        className="mt-1"
                      >
                        {item.property_category == 1
                          ? t("Residential")
                          : t("Commercial")}
                      </HeadingStyledSm>
                    </Box>
                    <Box className="advIdentityPlatform ">
                      <SpanStyled size="14px" color="var(--lightGrey)">
                        {t("Property_Type")}
                      </SpanStyled>
                      <br />
                      <HeadingStyledSm
                        size="14px"
                        color="var(--darkGrey)"
                        className="mt-1"
                      >
                        {language === "en"
                          ? item.property_type_data[0].en_name
                          : item.property_type_data[0].ar_name}
                      </HeadingStyledSm>
                    </Box>
                    {item?.customer_type && (
                      <Box className="advIdentityPlatform ">
                        <SpanStyled size="14px" color="var(--lightGrey)">
                          {t("AdvertiserRoles")}
                        </SpanStyled>
                        <br />
                        <HeadingStyledSm
                          size="14px"
                          color="var(--darkGrey)"
                          className="mt-1"
                        >
                          {resolveAdvertiserRoleLabel(
                            item?.customer_type,
                            advertiserTypes
                          )}
                        </HeadingStyledSm>
                      </Box>
                    )}

                    {item?.bedrooms && (
                      <Box className="advIdentityPlatform ">
                        <SpanStyled size="14px" color="var(--lightGrey)">
                          {t("Bedrooms")}
                        </SpanStyled>
                        <br />
                        <HeadingStyledSm
                          size="14px"
                          color="var(--darkGrey)"
                          className="mt-1"
                        >
                          {item.bedrooms == 10
                            ? "9+"
                            : item.bedrooms == 11
                            ? t("Studio")
                            : item?.bedrooms || "N/A"}
                        </HeadingStyledSm>
                      </Box>
                    )}
                    {!item?.bedrooms && item?.inside_mall_only_bit == 1 && (
                      <Box className="advIdentityPlatform ">
                        <SpanStyled size="14px" color="var(--lightGrey)">
                          {t("Inside_Mall_Only")}
                        </SpanStyled>
                        <br />
                        <HeadingStyledSm
                          size="14px"
                          color="var(--darkGrey)"
                          className="mt-1"
                        >
                          {item?.inside_mall_only_bit == 1 ? t("yes") : t("no")}
                        </HeadingStyledSm>
                      </Box>
                    )}
                    {/* <Box className="advIdentityPlatform col-5 col-lg-3">
                      <SpanStyled size="14px" color="var(--lightGrey)">
                        {t("Price_Range")}
                      </SpanStyled>
                      <br />
                      <HeadingStyledSm
                        size="14px"
                        color="var(--darkGrey)"
                        className="mt-1"
                      >
                        {item.price}
                      </HeadingStyledSm>
                    </Box> */}
                  </Box>
                  <Box className="d-flex justify-content-end mt-3">
                    <Box
                      className="d-flex align-items-center contact-btn gap-1"
                      style={{ cursor: "pointer" }}
                      onClick={WhatsApp}
                    >
                      <Whatsapp width={25} height={24} />
                      <SpanStyled color="var(--themeColorSecondary)">
                        {t("contact_us")}
                      </SpanStyled>
                    </Box>
                  </Box>
                </Box>
              </Box>
            ))}
        </Box>
      ) : (
        <Box className="d-flex justify-content-center">
          <HeadingStyled>{t("no_listing_found")}</HeadingStyled>
        </Box>
      )}
      {/* {!isDesktop && !showAll && propertiesList.length > 3 && (
        <Box className="w-100 d-flex justify-content-center mt-2">
          <ButtonStyled
            label={t("ViewAll")}
            bg="var(--white)"
            iconAfter={language == "en" ? BackwardArrow : ForwardArrow}
            border="var(--border)"
            color="var(--themeColorSecondary)"
            onClick={() => setShowAll(true)}
          />
        </Box>
      )} */}
    </>
  );
};

export default VisitorLookingForCards;
